'use strict';

import { createVueInstance } from './helpers/vue-instance';
import { toggleSubscription } from './_vue-functions';

createVueInstance({
	el: '[data-init="watch-pop-over"]',
	delimiters: ['$({', '})'],
	methods: {
		decideActionWatchList: toggleSubscription
	}
});
